import PropTypes from "prop-types";
import "./styles.scss";

const Card = ({ children, style, className, actionsContainer, ...rest }) => (
    <div className="card-wrapper">
        <div className={`ui-card ${className}`} style={style} {...rest}>
            {children}
        </div>
        {actionsContainer && (
            <div className="actions-container">
                {actionsContainer}
            </div>
        )}
    </div>
);
Card.defaultProps = {
    style: {},
    className: "",
    actionsContainer: null
};

Card.propTypes = {
    children: PropTypes.node,
    style: PropTypes.object,
    className: PropTypes.string,
    actionsContainer: PropTypes.node
};

export default Card;
